<template>
  <div class="home-content">
      <div class="mine-header"><span @click="util.goblack()" class="back"><img src="@/assets/images/base/icon_righ_g.png"/></span>Site Notification</div>
      <div class="third-pard">
        <div v-show="!nodata">
          <div class="list" v-for="(i,index) in list" v-bind:key="index">
            <ul @click="controlDisplay(index)">
              <li class="b-title">{{i.broadcast_title}}</li>
              <li class="b-time" v-show="isDetail==index">{{util.formatTime(i.add_time)}}</li>
              <textarea readonly class="b-content" v-show="isDetail==index" v-html="i.broadcast_content"></textarea>
            </ul>
          </div>
        </div>
        <div class="nodata" v-show="nodata"><img src="@/assets/images/icon/data_icon_219962.png"/><span>No data available</span></div>
        <div class="show-more" v-if="list.length>=10" @click="showMore()">{{hasMore?"See more records, click here":"No more data"}}</div>
      </div>
      <van-loading v-show="showloding" size="50px" color="#1989fa" vertical/>
  </div>
</template>
<script>
  import Vue from "vue";
  import { Loading } from "vant";
  Vue.use(Loading);
  export default {
    data() {
      return {
        showloding: false,
        timeType:1,
        nodata:true,
        status:1,
        pageNo:1,
        pageSize:10,
        hasMore:true,
        list:[],
        category:0,
        one:{},
        isDetail:-1,
      };
    },
    methods: {
      showMore(){
        if(this.hasMore){
          this.pageNo += 1;
          this.getMessage();
        }
      },
      controlDisplay(index){
        this.isDetail = index;
      },
      getMessage() {
        this.showloding = true;
        let params = {category :this.category}
        this.util.setDnValueToken(params);
        params.pageNo = this.pageNo;
        params.pageSize = this.pageSize;
        this.axios.get(this.api.api_getMessage, {params: params}) .then(res => {
            if(this.pageNo==1) this.nodata = true;
            this.showloding = false;
            if (res.data.code == 0) {
              let list = res.data.data;
              if(list.length>0) {
                this.nodata = false;
                this.list = this.list.concat(list);
              }else{
                this.hasMore = false;
              }
            } else {
              this.util.checkToken(res.data.message);
            }
          });
      },
    },
    activated(){
      if(this.util.isLogin()){
        this.userInfo = this.util.user;
        this.list = [];
        this.getMessage();
      }
    }
  };
  </script>
  <style lang="scss" scoped>
  .home-content{
    font-size: 0.32rem;
    background: rgb(235, 235, 235);
    color:rgb(103, 103, 103);
    width: 100%;
    height: 100%;
    .mine-header{
      color:black;
      font-weight: bold;
      height: 1.2rem;
      display: grid;
      grid-template-columns: 30% 1fr 30%;
      align-items: center;
      text-align: center;
      .back{
        cursor: pointer;
        img{
          display: block;
          margin-left: 5%;
          width: 0.5rem;
          transform: rotate(180deg);
        }
      }
    }
    .third-pard{
      height: 100%;
      padding-bottom: 160px;
      overflow-y: auto;
      scrollbar-width: none;
      -ms-overflow-style: none;
      .nodata{
        margin-top: 50px;
        height: 50px;
        display: grid;
        justify-content: center;
        font-size: 0.34rem;
        img{
          display: block;
          width: 35px;
          margin: auto;
        }
      }
      .show-more{
        height: 50px;
        display: flex;
        cursor: pointer;
        justify-content: center;
        align-items: center;
      }
      .list{
        width: 97%;
        display: grid;
        grid-template-columns: 1fr 2%;
        align-items: center;
        margin: 10px auto;
        margin-top: 0;
        border-radius: 10px/10px;
        background-color: white;
        padding: 10px 20px;
        .b-title{
          font-size: 0.32rem;
          text-align: center;
          font-weight: bold;
          color:black;
        }
        .b-time{
          font-size: 0.32rem;
          padding: 1px 0;
          text-align: center;
        }
        .b-content{
          height: 500px;
          border: none;
          font-size: 0.32rem;
        }
      }
    }
  }
  </style>  